var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"width":"100%","height":"400px"},attrs:{"id":"PullRequestSample"}}),_c('div',{staticStyle:{"width":"100%","height":"400px","margin-top":"60px"},attrs:{"id":"PullRequestThrpt"}})])
}]

export { render, staticRenderFns }